import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";
import { assignRecursive } from "../../utils";
// import { ErrorType } from "../../components/modals/Error";

const animations = createSlice({
  name: "animations",
  initialState: initialState.animations,
  reducers: {
    addAnimation(state, action: PayloadAction<string>) {
      if (state[action.payload]) return state;

      return { ...state, [action.payload]: {} };
    },
    setAnimation(state, action: PayloadAction<{ name: string; props: any }>) {
      const { name, props } = action.payload;
      if (!state[name]) return state;
      const newState = assignRecursive(state[name], props);

      return { ...state, [name]: newState };
    },
  },
});

export const { addAnimation, setAnimation } = animations.actions;

export default animations;
